module.exports = __webpack_public_path__ + "img/tr.453ef0d2.svg";